import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

const DiscardAllocationConfirmDialog = ({ open, onClose, onConfirm, loading }) => (
  <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth='sm' fullWidth>
    <DialogTitle>
      <Typography variant='h6' fontWeight={700}>
        Discard Active Allocation?
      </Typography>
    </DialogTitle>
    <DialogContent>
      <Alert severity='warning'>
        This will release the allocated quantity back to inventory and cannot be undone. You will
        need to select lots again to fulfill this item.
      </Alert>
    </DialogContent>
    <DialogActions>
      <Button variant='text' onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <LoadingButton variant='contained' color='error' onClick={onConfirm} loading={loading}>
        Discard Allocation
      </LoadingButton>
    </DialogActions>
  </Dialog>
);

DiscardAllocationConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

DiscardAllocationConfirmDialog.defaultProps = {
  loading: false,
};

export default DiscardAllocationConfirmDialog;
